import { HttpParams } from '@angular/common/http';
import { DateTime } from 'luxon';
import { FilterParams } from '@models/api/requests';

export class HttpParamsUtils {
  /**
   * Adds filter parameters to HttpParams, excluding null, undefined, and empty string values
   * @param params Initial HttpParams object
   * @param filters Object containing filter parameters
   * @returns HttpParams with added filter parameters
   */
  static addFilterParams(params: HttpParams, filters: Record<string, any> | null | undefined): HttpParams {
    if (!filters) {
      return params;
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value.toString());
      }
    });

    return params;
  }

  /**
   * Adds typed FilterParams to HttpParams with special handling for date fields
   * @param params Initial HttpParams object
   * @param filters FilterParams object
   * @returns HttpParams with added filter parameters
   */
  static addTypedFilterParams(params: HttpParams, filters?: FilterParams): HttpParams {
    if (!filters) {
      return params;
    }

    if (filters.emetteur) {
      params = params.set('emetteur', filters.emetteur);
    }
    if (filters.typeDemande) {
      params = params.set('typeDemande', filters.typeDemande);
    }
    if (filters.direction) {
      params = params.set('direction', filters.direction);
    }
    if (filters.serviceFonctionnel) {
      params = params.set('serviceFonctionnel', filters.serviceFonctionnel);
    }
    if (filters.numeroPoste) {
      params = params.set('numeroPoste', filters.numeroPoste);
    }
    if (filters.agentRenouveleId) {
      params = params.set('agentRenouveleId', filters.agentRenouveleId);
    }
    if (filters.agentRenouvele) {
      params = params.set('agentRenouvele', filters.agentRenouvele);
    }
    if (filters.statut) {
      params = params.set('statut', filters.statut);
    }
    if (filters.dateCreation) {
      const startDate = filters.dateCreation.set({ hour: 0, minute: 0, second: 0 }).toFormat("yyyy-MM-dd'T'HH:mm:ss");
      params = params.set('dateCreation', startDate);
    }
    if (filters.dateCreationStart) {
      params = params.set('dateCreationStart', filters.dateCreationStart);
    }
    if (filters.dateCreationEnd) {
      params = params.set('dateCreationEnd', filters.dateCreationEnd);
    }
    if (filters.typeRecrutement) {
      params = params.set('libelleDetailType', filters.typeRecrutement);
    }
    if (filters.typeRenouvellement) {
      params = params.set('libelleDetailType', filters.typeRenouvellement);
    }

    return params;
  }
}
